import { IItemPage } from "../types/item";
import { IAlbum, IModifyAlbumResponse } from "../types/photo";

export function filterAlbumsAuto(albumsPage: IItemPage<IAlbum>): IItemPage<IAlbum> {
  return {
    ...albumsPage,
    value: albumsPage.value.filter((album) => !album.tags || !album.tags.find((tag) => tag.name === "__Auto"))
  };
}

export function processModifyAlbumResponse(results: PromiseSettledResult<IModifyAlbumResponse>[], photoIds: string[], batchSize: number)
  : { flattenedResult: PromiseSettledResult<void>[], modifiedPhotoIds: string[] } {
  // NOTE: COB add to album API will return a list of results coresponding to each photo to add.
  // If the photo is added successfully, the photo item result (defined as photoResult below) will only return
  // id, otherwise it will return with an error object.

  const flattenedResult: PromiseSettledResult<void>[] = [];
  const modifiedPhotoIds: string[] = [];

  results.forEach((result, index) => {
    if (result.status === 'fulfilled') {
      result.value.value.forEach((photoResult) => {
        if (!photoResult.error) {
          flattenedResult.push({
            status: 'fulfilled',
            value: undefined
          })
          modifiedPhotoIds.push(photoResult.id);
        } else {
          flattenedResult.push({
            status: 'rejected',
            reason: photoResult.error.code
          })
        }
      });
    } else {
      photoIds.slice(index * batchSize, (index + 1) * batchSize).forEach(photo => {
        flattenedResult.push({
          status: "rejected",
          reason: result.reason
        })
      });
    }
  })

  return { flattenedResult, modifiedPhotoIds };
}